import { convertKeysToSnakeCase } from '@mc/products'
import { EventTypes, track, getPageSource } from '@mc/track-event'

export interface PromoPageCtaClickProps {
  action: string
  location: string
  href?: string
  /**
   * Extra properties, snake-cased before firing. They never replace `action`,
   * `location`, `href` or `page_source`.
   */
  properties?: Record<string, unknown>
}

/**
 * The promotion page's own CTA click — "Promo Page Click", the event that page
 * uses for every other interaction (FAQ links, third-party validation, the
 * gift button via `getPageEventName`). /2-for-1-offer fires
 * "Holiday Page Click" instead; the two surfaces are deliberately separate
 * events.
 *
 * Deliberately NOT a purchase-funnel event: /promotion is a middle-funnel
 * page, so the upper-funnel CTA that sent the user here is the one that fires
 * "Purchase Click" → Meta AddToCart. Firing a purchase event here too would
 * double-count the funnel entry.
 */
export const trackPromoPageCtaClick = ({
  action,
  location,
  href,
  properties,
}: PromoPageCtaClickProps) =>
  track(EventTypes.PROMO_PAGE_CLICK, {
    ...(properties && convertKeysToSnakeCase(properties)),
    action,
    location,
    href,
    page_source: getPageSource(),
  })
